import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../contexts/LanguageContext';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  
  // Determine active page from current path
  const getActivePage = () => {
    const path = location.pathname;
    if (path === '/admin' || path === '/admin/dashboard') return 'dashboard';
    if (path === '/admin/menus') return 'menus';
    if (path === '/admin/categories') return 'categories';
    if (path === '/admin/dishes') return 'dishes';
    if (path === '/admin/add-item') return 'add-item';
    if (path === '/admin/settings') return 'settings';
    return 'dashboard';
  };

  const setActivePage = (page) => {
    navigate(page === 'dashboard' ? '/admin/dashboard' : `/admin/${page}`);
  };

  const menuItems = [
    { id: 'dashboard', label: t('dashboard') },
    { id: 'menus', label: t('menus') },
    { id: 'categories', label: t('categories') },
    { id: 'dishes', label: t('dishes') },
    { id: 'add-item', label: t('addItem') },
    { id: 'settings', label: t('settings') },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">🍴</div>
          <span>Admin</span>
        </div>
      </div>
      
      <div className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${getActivePage() === item.id ? 'active' : ''}`}
            onClick={() => setActivePage(item.id)}
          >
            <span>{item.label}</span>
          </button>
        ))}
      </div>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">A</div>
          <div className="sidebar-user-info">
            <div className="sidebar-user-name">Admin User</div>
            <div className="sidebar-user-role">Administrator</div>
          </div>
          <div className="sidebar-user-status"></div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
